"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuthDto = instanceOfAuthDto;
exports.AuthDtoFromJSON = AuthDtoFromJSON;
exports.AuthDtoFromJSONTyped = AuthDtoFromJSONTyped;
exports.AuthDtoToJSON = AuthDtoToJSON;
exports.AuthDtoToJSONTyped = AuthDtoToJSONTyped;
var UserDto_1 = require("./UserDto");
/**
 * Check if a given object implements the AuthDto interface.
 */
function instanceOfAuthDto(value) {
    if (!('accessToken' in value) || value['accessToken'] === undefined)
        return false;
    if (!('idToken' in value) || value['idToken'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined)
        return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    return true;
}
function AuthDtoFromJSON(json) {
    return AuthDtoFromJSONTyped(json, false);
}
function AuthDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accessToken': json['accessToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
        'refreshToken': json['refreshToken'],
        'user': (0, UserDto_1.UserDtoFromJSON)(json['user']),
    };
}
function AuthDtoToJSON(json) {
    return AuthDtoToJSONTyped(json, false);
}
function AuthDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accessToken': value['accessToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
        'refreshToken': value['refreshToken'],
        'user': (0, UserDto_1.UserDtoToJSON)(value['user']),
    };
}
